import { Effect } from "../../Materials/effect";
var name = 'diffusionProfile';
var shader = "uniform vec3 diffusionS[5];\nuniform float diffusionD[5];\nuniform float filterRadii[5];";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var diffusionProfile = { name: name, shader: shader };
